import 'babel-polyfill';
import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router/router';
import store from '@/store';
import titleMixin from '@/titleMixin';
import dialogBase from '@/components/common/Dialog/dialogBase.js';
import currency from '@/components/common/Formatter/Currency/currency.js';
import accessControl from './helpers/accessControl.js';
import enums from './helpers/enums.js';
import moment from './helpers/moment.js';
import { servicesPlugin } from '@/plugins/services';
import { notificationPlugin } from '@/plugins/notifications';
import { modalPlugin } from '@/plugins/modals';
import { whitelabelPlugin } from "@/plugins/whitelabel";
// import { initializeKeycloak } from '@/helpers/keycloakInit';
import i18n from "@/plugins/i18n";
import createVuetify from './plugins/vuetify'

export const vuetify = createVuetify(store)

Vue.mixin(titleMixin);
Vue.mixin(moment);

Vue.use(servicesPlugin);
Vue.use(notificationPlugin);
Vue.use(modalPlugin);
Vue.use(whitelabelPlugin)

Vue.config.productionTip = false;
Vue.prototype.config = window.config;

async function mountApp() {
  new Vue({
    router,
    store,
    vuetify,
    i18n,
    dialogBase,
    currency,
    accessControl,
    enums,
    render: h => h(App)
  }).$mount('#app');
}

// if (window.config.VUE_APP_STAGE === 'DEVELOP' || window.config.VUE_APP_STAGE === 'TEST') {
//   initializeKeycloak()
//     .then(async (keycloak) => {
//       if (keycloak) Vue.prototype.$keycloak = keycloak; // Keycloak-Instanz global verfügbar machen
//       await mountApp();
//     })
//     .catch(async () => {
//       console.error('Keycloak failed to initialize');
//       await mountApp();
//     });
// } else {
  mountApp();
// }
